import React, { FunctionComponent } from 'react';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

interface Covid19DisclaimerProps {
  handleReturnToDashboard: () => void;
  handleStepChange: () => void;
}

export const Covid19Disclaimer: FunctionComponent<Covid19DisclaimerProps> = ({
  handleReturnToDashboard,
  handleStepChange,
}) => {
  return (
    <div data-testid="covid-disclaimer">
      <p className="owners-body">
        If you’re experiencing exceptional circumstances, you can apply for a
        refund of credit on your account and we’ll get in touch to confirm
        you’re eligible for a refund
      </p>
      <Button fullWidth variant="contained" onClick={() => handleStepChange()}>
        Continue with application
      </Button>
      <Button
        fullWidth
        variant="outlined"
        onClick={() => handleReturnToDashboard()}
      >
        Return to dashboard
      </Button>
    </div>
  );
};
